<script lang="ts" setup>
import type { LocaleObject } from '@nuxtjs/i18n';

const { locales, locale, t } = useEkI18n();
const settingsStore = useSettingsStore();
const userConfigurationAPI = useConfigurationAPI();

const selectedLocale = computed(() => locales.value.find((l) => l.code === settingsStore.settings.language));

async function setLanguage(locale: LocaleObject) {
  await settingsStore.set('language', locale.code);
  const localeUpdate: UserLocale = {
    Locale: locale.code
  };
  await userConfigurationAPI.UpsertLocale(localeUpdate);
}
</script>

<template>
  <SettingsSelect
    :options="locales"
    :label="t('settings.general.language')"
    :placeholder="locale"
    :value="selectedLocale"
    :resolve-key="(o: LocaleObject)=>o.code"
    @change="setLanguage"
  >
    <template #option="{ option }">
      {{ option.name }}
    </template>
  </SettingsSelect>
</template>

<style scoped></style>
